import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(
    private httpService: HttpService,
    private router: Router,
  ) {
  }

  private technicianInvoicesPath = 'technician-invoices';
  private technicianInvoicePath = 'technician-invoice';
  private emailTechnicianInvoicesPath = 'email-technician-invoice';
  private invoicePath = '/invoice/';
  private confirmTechnicianInvoicePath = 'confirm-technician-invoice';

  getTechnicianInvoices(page): Observable<any> {
    return this.httpService.httpGet(this.technicianInvoicesPath + '?page=' + page).pipe(response => {
      return response;
    });
  }

  getTechnicianInvoice(id): Observable<any> {
    return this.httpService.httpGet(this.technicianInvoicePath + '/' + id).pipe(response => {
      return response;
    });
  }

  emailTechnicianInvoice(body): Observable<any> {
    return this.httpService.httpPost(this.emailTechnicianInvoicesPath, body).pipe(response => {
      return response;
    });
  }

  confirmTechnicianInvoice(body): Observable<any> {
    return this.httpService.httpPut(this.confirmTechnicianInvoicePath, body).pipe(response => {
      return response;
    })
  }

  openInvoice(invoiceId){
    this.router.navigate([this.invoicePath, invoiceId]);
  }

  openInvoices(){
    this.router.navigate(['/invoices']);
  }

}
